import {PLAYERS_ROUTER_ROOT, PLAYERS_ROUTER_NEW, PLAYERS_ROUTER_EDIT} from './constants';
import {connect} from 'react-redux';
import {push} from 'react-router-redux/lib/actions';
import PlayersList from './PlayersList';
import PlayersNew from './PlayersNew';
import PlayersEdit from './PlayersEdit';
import CRUDActions from '../../actions/player';

const settings = {
  router: [
    {
      path: PLAYERS_ROUTER_ROOT,
      component: PlayersList
    },
    // new
    {
      path: PLAYERS_ROUTER_NEW,
      component: connect(undefined, dispatch => ({
        onClose: () => Promise.resolve(dispatch(CRUDActions.onCloseEditForm()))
          .then(() => dispatch(push(PLAYERS_ROUTER_ROOT)))
      }))(PlayersNew)
    },
    // edit
    {
      path: PLAYERS_ROUTER_EDIT,
        component: connect(undefined, dispatch => ({
        onClose: () => dispatch(push(PLAYERS_ROUTER_ROOT))
    }))(PlayersEdit)
    }
  ]
};

export default settings;



// WEBPACK FOOTER //
// ./src/components/Players/index.js